<template>
  <v-dialog v-model="show" width="600" ref="sepDropdown">
    <v-card>
      <v-card-text>
        <v-col cols="12">
          <v-text-field
            v-if="searchable == 'true'"
            class="m-1"
            style="font-size: 13px"
            dense
            append-icon="mdi-file-find"
            placeholder="جست و جو کنید"
            solo
            hide-details
            v-model="searchItem"
            @keyup="searchHandler"
          ></v-text-field>
        </v-col>
        <b-table
          striped
          hover
          :items="itemsList"
          :fields="fields"
          class="mt-3"
          style="max-height: 300px; min-height: 200px"
          outlined
          responsive
        >
          <template
            v-for="(_, slotName) of $scopedSlots"
            v-slot:[slotName]="scope"
          >
            <slot :name="slotName" v-bind="scope" />
          </template>
          <template #cell(index)="item">
            {{ item.index + 1 }}
          </template>
          <template #cell(actions)="item">
            <v-btn
              @click="editItem(item)"
              class="mx-1"
              fab
              x-small
              color="cyan"
              dark
            >
              <v-icon dark> mdi-pencil </v-icon>
            </v-btn>
          </template>
        </b-table>

        <div class="custom-list__btns">
          <div v-if="items.length && pagination">
            <v-tooltip bottom v-if="!this.hideArrow">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="blue "
                  class="show-more__animate"
                  @click="expandOptions"
                >
                  mdi mdi-chevron-down
                </v-icon>
              </template>
              <span>نتایج بیشتر</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="blue"
                  @click="resetOptions"
                >
                  mdi mdi-chevron-up
                </v-icon>
              </template>
              <span>بازگشت به نتایج کمتر</span>
            </v-tooltip>
          </div>
          <div class="text-right d-flex">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  @click="refreshOptions"
                >
                  <v-icon class="transition">mdi-cached </v-icon>
                </v-btn>
              </template>
              <span>بروزرسانی</span>
            </v-tooltip>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CustomList',
  props: {
    items: {
      type: Array,
      default: [],
    },
    fields: {
      type: Array,
      default: [],
    },

    editable: {
      type: String,
      default: 'true',
    },
    value: {
      type: Boolean,
      default: 'false',
    },

    searchable: {
      type: [String, Boolean],
      default: 'true',
    },
    pagination: {
      type: [String, Boolean],
      default: true,
    },
  },

  data() {
    return {
      pageNumber: 1,
      itemsPerPage: 5,
      isBusy: false,
      startRefresh: false,
      searchItem: null,
      searching: false,
      limitOptionsLength: 5,
      hideArrow: false,
      itemsList: [],
      limitedOptions: [],
      option: null,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    items(after) {
      if (after) {
        if (!after.length) {
          ('**end**');
          this.hideArrow = true;
        }
        this.itemsList.push(...this.items);
      }
    },
  },

  mounted() {
    this.$emit('getOptions', this.pageNumber, this.itemsPerPage);
  },

  methods: {
    closeSelectBox() {
      this.resetOptions();
      this.showList = false;
    },
    showLabel(item) {
      return item.length > 15 ? item.slice(0, 15) + '...' : item;
    },
    editItem(item) {
      this.$emit('edit', item);
    },
    addOptions() {
      this.$emit('createNewOption');
    },
    refreshOptions() {
      let c = document.querySelector('.transition');
      c.classList.add('refresh');
      this.resetOptions();
      setTimeout(() => {
        if (c.classList.contains('refresh')) {
          c.classList.remove('refresh');
        }
      }, 1000);
    },
    searchHandler() {
      if (this.searching) {
        clearTimeout(this.searching);
      }
      this.searching = setTimeout(() => {
        this.searching = true;
        if (this.searchItem.length == 0) {
          this.resetOptions();
        } else {
          this.itemsList = [];
          this.$emit('search', this.searchItem);
        }
      }, 600);
    },
    addtab(href, title) {
      let sendObj = { to: href, name: title };
      this.$store.dispatch('addTab', sendObj);
    },
    resetOptions() {
      this.isBusy = true;
      let $vm = this;
      $vm.pageNumber = 1;
      $vm.itemsList = [];
      $vm.$emit('getOptions', $vm.pageNumber, $vm.itemsPerPage);
      $vm.hideArrow = false;
    },
    expandOptions() {
      this.pageNumber++;
      this.$emit('getOptions', this.pageNumber, this.itemsPerPage);
    },
    selectItem(option) {
      this.$emit('select', option);
    },
    translate(en) {
      const Fa = {
        NotReceived: 'دریافت نشده',
        Received: 'دریافت شده',
        Receiving: 'درحال دریافت',
        NoFoundation: 'بدون مبنا',
        entryPermit: 'مجوز ورود',
        exitPermit: 'مجوز خروج',
        ReserveInWarehouse: 'رزرو در انبار',
        RequestFromWarehouse: 'درخواست از انبار',
        TemporaryDocument: 'سند موقت',
        Buy: 'خرید',
        Production: 'تولید',
        Consumption: 'مصرف',
        Wastage: 'خرید',
        TransferBetweenWarehouse: 'انتقال',
        WarehouseHandling: 'انبار گردانی',
        Amani: 'امانی',
        Other: 'دیگر',
      };

      return Fa[en];
    },
  },
};
</script>

<style scoped>
.custom-list__btns {
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  text-align: center;
  z-index: 1000;
  width: 100%;
  background: white;
  background: white;
  border-top: none;
}
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: rgba(0, 0, 0, 0.87) !important;
  z-index: 10000;
  background: white;
}
.v-list {
  padding-bottom: 0;
}
.rotate {
  transform: rotate(180deg);
}

.transition {
  transition: all 4s linear;
}
.refresh {
  animation-name: rotate;
  animation-duration: 1s;
}

.show-more__animate {
  animation-name: translate;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.sep-dropdown-list {
  max-height: 230px;
  overflow: scroll;
}
.sep-bg-label {
  background: rgb(240, 240, 240) none repeat scroll 0% 0%;
  color: #4d4d4d !important;
}
@keyframes translate {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(180deg);
  }
}
</style>
